/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundDto } from '../../models/backend-venture-fund-dto';
import { BackendVentureFundRequestDto } from '../../models/backend-venture-fund-request-dto';

export interface VentureFundsVentureFundsCreate$FormData$Params {
  body: BackendVentureFundRequestDto;
}

export function ventureFundsVentureFundsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundDto>;
    }),
  );
}

ventureFundsVentureFundsCreate$FormData.PATH = '/api/venture_funds/venture-funds/';
